import React from 'react'

import Layout from 'components/Layout'
import Nav from 'components/Nav'
import { InvestmentProduct, PortfolioTheme } from 'generated/types'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'

import { PortfolioThemes } from '../select-portfolio'
import AboutPortfolioContent from './AboutPortfolioContent'

const AboutPortfolio = (props: WithFlowRouterProps) => {
  const INVEST = InvestmentProduct.Invest.toLowerCase()
  const LATER = InvestmentProduct.Later.toLowerCase()

  let productTheme = props?.location?.state?.selectedTheme || PortfolioThemes.CORE
  if (productTheme === PortfolioThemes.SUSTAINABLE) {
    productTheme = PortfolioTheme.Sustainable.toLowerCase()
  }

  return (
    <>
      <Nav back={true} hideProgressBar={false} title="About portfolio" />
      <Layout>
        <AboutPortfolioContent
          product={props?.location?.state?.product.toLowerCase()}
          theme={productTheme.toLowerCase()}
          recommendedRisk={props?.location.state?.recommendedRisk}
          investType={INVEST}
          laterType={LATER}
        />
      </Layout>
    </>
  )
}

export default withFlowRouter(AboutPortfolio)
